import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

const mockData = [
  { month: 'Jan', donors: 12 },
  { month: 'Feb', donors: 19 },
  { month: 'Mar', donors: 15 },
  { month: 'Apr', donors: 27 },
]

export function DonorChart() {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={mockData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="donors"
          stroke="hsl(var(--primary))"
          fill="hsl(var(--primary) / 0.2)"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
